<template>
  <Box rounded="xlarge" class="tw-flex tw-max-h-[718px] tw-w-full tw-flex-col tw-overflow-y-auto">
    <div class="tw-pb-5">
      <div class="tw-flex tw-items-start tw-justify-between tw-gap-4">
        <div v-if="currentVersionLabel" class="tw-flex tw-items-center tw-gap-2">
          <Text>{{ t('sidebar_status.current_version') }}</Text>
          <Tag color="gradient" size="small">{{ currentVersionLabel }}</Tag>
        </div>

        <div class="tw-flex tw-flex-col tw-items-end tw-gap-1">
          <Tag :color="nateStatusUi.color" size="small">
            {{ nateStatusUi.label }}
          </Tag>

          <Link href="#" scheme="underline" @click.prevent="openNateLogs">Show NATE logs</Link>
        </div>
      </div>
    </div>

    <div class="tw-border-t tw-border-purple/25 tw-py-5">
      <WanSection @refresh="refreshWanStatus" />
    </div>

    <div v-if="nateUptimeText !== null" class="tw-border-t tw-border-purple/25 tw-py-5">
      <UptimeDisplay :uptime-text="nateUptimeText" :started-at-text="nateStartedAtText" />
    </div>

    <div class="tw-border-t tw-border-purple/25 tw-py-5">
      <WiringSection :mode="wiringDisplayMode" :rows="wiringDisplayRows" />
    </div>

    <div v-if="showVersions" class="tw-flex-1 tw-border-t tw-border-purple/25 tw-py-5">
      <div class="tw-space-y-4 tw-divide-y tw-divide-purple/25">
        <VersionCard
          v-if="stable.versionState !== 'up_to_date' && stable.versionState !== 'no_version'"
          kind="stable"
          :state="stable.versionState"
          :displayed-version="stable.displayedVersion"
          :remote="stable.remote"
          :estimated-minutes="stable.estimatedMinutes"
          :progress="stable.progressPct"
          :remaining-time-text="stable.remainingTimeText"
          @download="() => download('stable')"
          @run="() => run('stable')"
          @open-logs="openLogs"
        />

        <VersionCard
          v-if="beta.versionState !== 'up_to_date' && beta.versionState !== 'no_version'"
          kind="beta"
          :state="beta.versionState"
          :displayed-version="beta.displayedVersion"
          :remote="beta.remote"
          :estimated-minutes="beta.estimatedMinutes"
          :progress="beta.progressPct"
          :remaining-time-text="beta.remainingTimeText"
          @download="() => download('beta')"
          @run="() => run('beta')"
          @open-logs="openLogs"
        />

        <VersionCard
          v-if="devVisible && dev.versionState !== 'up_to_date' && dev.versionState !== 'no_version'"
          kind="dev"
          :state="dev.versionState"
          :displayed-version="dev.displayedVersion"
          :remote="dev.remote"
          :estimated-minutes="dev.estimatedMinutes"
          :progress="dev.progressPct"
          :remaining-time-text="dev.remainingTimeText"
          :show-run="false"
          @download="() => download(dev.remote?.tag)"
          @open-logs="openLogs"
        />
      </div>
    </div>

    <LogsModal v-model="showLogs" :kind="logsKind" />
  </Box>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import { Box, Link, Tag, Text } from '@slideslive/fuse-kit/vue';

import LogsModal from '@/components/LogsModal.vue';
import UptimeDisplay from '@/components/sidebar/UptimeDisplay.vue';
import VersionCard from '@/components/sidebar/VersionCard.vue';
import WanSection from '@/components/sidebar/WanSection.vue';
import WiringSection from '@/components/sidebar/WiringSection.vue';
import sidebarStatus from '@/composables/sidebar_status';

const { t } = useI18n();

const {
  currentVersionLabel,
  nateStatusUi,
  nateUptimeText,
  nateStartedAtText,
  wiringDisplayMode,
  wiringDisplayRows,
  stable,
  beta,
  dev,
  devVisible,
  showVersions,
  download,
  run,
  refreshWanStatus,
  showLogs,
  logsKind,
  openLogs,
  openNateLogs,
} = sidebarStatus();
</script>
